/**
 * @desc transferInBatchManager
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.BatchMasterCreateRequestParamDto, options?: any) {
  return updateResponse(
    http(URL + `/Batch/transferInWarehouse`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
